import React from 'react';
import './ActiveTourneyMsg.scss';

export const ActiveTourneyMsg = () => (<div className="ActiveTourneyMsg">
  <p>
    PVP TOURNAMENT LIVE NOW !!
  </p>
</div>);
